import React from 'react';
import { Skeleton } from 'gatorcomponents';
import * as Styles from './AdsInsightsSkeleton.styles';

const AdsInsightsSkeleton = () => (
  <Styles.ContentWrapper>
    <Styles.SectionContainer $padding="40px 24px">
      <Styles.StatsContainer>
        <Styles.StatItem>
          <Skeleton variant="circle" width="40px" height="40px" />
          <Styles.StatContent>
            <Skeleton variant="rectangle" width="140px" height="16px" />
            <Skeleton variant="rectangle" width="100px" height="12px" />
            <Skeleton variant="rectangle" width="60px" height="32px" />
          </Styles.StatContent>
        </Styles.StatItem>

        <Styles.StatDivider />

        <Styles.StatItem>
          <Skeleton variant="circle" width="40px" height="40px" />
          <Styles.StatContent>
            <Skeleton variant="rectangle" width="140px" height="16px" />
            <Skeleton variant="rectangle" width="100px" height="12px" />
            <Skeleton variant="rectangle" width="60px" height="32px" />
          </Styles.StatContent>
        </Styles.StatItem>

        <Styles.StatsButtonWrapper>
          <Skeleton variant="button" width="180px" height="48px" />
        </Styles.StatsButtonWrapper>
      </Styles.StatsContainer>
    </Styles.SectionContainer>

    <Styles.TrendingPostContainer>
      <Styles.TrendingPostImageWrapper>
        <Skeleton variant="rectangle" width="176px" height="284px" borderRadius="8px" />
      </Styles.TrendingPostImageWrapper>

      <Styles.TrendingPostContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Skeleton variant="circle" width="40px" height="40px" />
          <Skeleton variant="rectangle" width="280px" height="24px" />
          <Skeleton variant="rectangle" width="100%" height="48px" />
        </div>
        <Skeleton variant="button" width="200px" height="48px" />
      </Styles.TrendingPostContent>
    </Styles.TrendingPostContainer>

    <Styles.MainContentContainer>
      <Styles.SectionContainer>
        <Styles.RecentCampaignsContainer>
          <Skeleton variant="rectangle" width="250px" height="24px" />

          <Styles.CampaignsList>
            {[1, 2, 3].map(index => (
              <Styles.CampaignItem key={index}>
                <Skeleton variant="rectangle" width="103px" height="77px" borderRadius="8px" />
                <Styles.CampaignInfo>
                  <Skeleton variant="rectangle" width="120px" height="16px" />
                  <Skeleton variant="rectangle" width="100%" height="20px" />
                  <Skeleton variant="rounded" width="80px" height="24px" />
                </Styles.CampaignInfo>
              </Styles.CampaignItem>
            ))}
          </Styles.CampaignsList>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
            <Skeleton variant="button" width="180px" height="40px" />
          </div>
        </Styles.RecentCampaignsContainer>
      </Styles.SectionContainer>

      <Styles.SideCardsContainer>
        <Styles.ActionCard>
          <Skeleton variant="circle" width="40px" height="40px" />
          <Skeleton variant="rectangle" width="180px" height="20px" />
          <Skeleton variant="rectangle" width="100%" height="48px" />
        </Styles.ActionCard>

        <Styles.ActionCard>
          <Skeleton variant="rounded" width="100px" height="24px" />
          <Skeleton variant="circle" width="40px" height="40px" />
          <Skeleton variant="rectangle" width="180px" height="20px" />
          <Skeleton variant="rectangle" width="100%" height="48px" />
        </Styles.ActionCard>
      </Styles.SideCardsContainer>
    </Styles.MainContentContainer>
  </Styles.ContentWrapper>
);

export default AdsInsightsSkeleton;
